import * as React from 'react';
export const opencodeSvg = React.forwardRef(function opencodeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#211E1E',
      style: {
        fill: 'light-dark(#211e1e,#f1ecec)',
      },
      fillRule: 'evenodd',
      d: 'M8 5h16v22H8zm12 17.6h-8V9.4h8v13.2',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#CFCECD',
      style: {
        fill: 'light-dark(#cfcecd,#4b4646)',
      },
      d: 'M12 22.6h8v-8.8h-8z',
    }),
  );
});
opencodeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var opencode = {
  category: 'brand',
  colorable: false,
  name: 'opencode',
  svg: opencodeSvg,
};
